// 设备框架配置文件
// 这个文件将由脚本自动更新

// 导入设备图片
// 移除缺失的资源引用
// import macbookpro from '@assets/macbookpro.png';
// import macbookair from '@assets/macbook-air-little.png';
// import imacpro from '@assets/imac.png';
// import ipadpro from '@assets/ipad.png';
// import iphonepro from '@assets/iphone.png';
import { windowDark, windowLight } from '@utils/windowsIcon';

// 使用占位符替代不存在的图片
const placeholder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const deviceFrames = {
  basicFrames: {
    title: '基础框架',
    items: [
      { id: 'none', name: '无框架', type: 'basic' },
      { id: 'light', name: '白色框', type: 'basic', bgColor: '#ffffff' },
      { id: 'dark', name: '黑色框', type: 'basic', bgColor: '#000000' },
      { id: 'macosBarLight', name: 'macOS 亮色', type: 'basic' },
      { id: 'macosBarDark', name: 'macOS 暗色', type: 'basic' },
      { id: 'windowsBarLight', name: 'Windows 亮色', type: 'basic' },
      { id: 'windowsBarDark', name: 'Windows 暗色', type: 'basic' },
      { id: 'lightGray', name: '浅灰框', type: 'basic', bgColor: '#f5f5f5' },
      { id: 'darkGray', name: '深灰框', type: 'basic', bgColor: '#333333' },
      { id: 'coloredBorder', name: '彩色框', type: 'basic', bgColor: '#ffffff' },
      { id: 'gradientBorder', name: '渐变框', type: 'basic' },
      { id: 'roundedCorners', name: '圆角框', type: 'basic', bgColor: '#ffffff' },
      { id: 'shadowed', name: '阴影框', type: 'basic', bgColor: '#ffffff' },
      { id: 'dottedBorder', name: '波点边框', type: 'basic', bgColor: '#ffffff' },
      { id: 'heartDecorated', name: '爱心装饰', type: 'basic', bgColor: '#ffffff' },
      { id: 'bubbleFrame', name: '气泡框', type: 'basic', bgColor: '#ffffff' },
      { id: 'starDecorated', name: '星星装饰', type: 'basic', bgColor: '#ffffff' },
      { id: 'rainbowBorder', name: '彩虹边框', type: 'basic', bgColor: '#ffffff' },
    ]
  }
};

export default deviceFrames; 